import React from 'react'
import Table from '../../components/common/Table'
import { MemberFeeDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'
import { renderBooleanBadge } from '../../utils/displayUtils'

interface MemberFeeTableProps {
  data: MemberFeeDTO[];
  handleEdit: (row: MemberFeeDTO) => void;
  handleDelete: (row: MemberFeeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const MemberFeeTable: React.FC<MemberFeeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
                
                    {
                        label: "Name",
                        key: "name",
                    },
        
                    {
                        label: "Description",
                        key: "description",
                    },
        
                    {
                        label: "Is Active",
                        key: "isActive",
                        render: (row: MemberFeeDTO) => renderBooleanBadge(row.isActive ?? false),
                    },
        
                {
                    label: "Added",
                    key: "createdUtc",
                    format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
                },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default MemberFeeTable;
